export const translations = {
  en: {
    common: {
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      submit: "Submit",
      next: "Next",
      back: "Back",
      delete: "Delete",
      edit: "Edit",
      logout: "Log out",
    },
    nav: {
      dashboard: "Dashboard",
      chat: "Mentor Chat",
      decisions: "Decisions",
      goals: "Goals",
      reports: "Reports",
      journey: "My Journey",
      subscription: "Subscription",
      settings: "Settings",
      group_tools: "Tools",
      group_reflection: "Reflection",
      group_account: "Account",
    },
    landing: {
      brand: "BScanIA",
      tagline: "The Intelligent Partner Behind Every Strategic Decision.",
      subtitle: "BScanIA is your strategic, emotionally intelligent AI partner, enabling clear, non-impulsive decisions that align with organizational expectations. Designed for stakeholders and managers across multiple industries.",
      cta_start: "Start before your next big call",
      cta_login: "Log in",
      how_title: "How it works",
      how_subtitle: "Three steps to mental clarity",
      how_1_title: "Initial Scan",
      how_1_desc: "Complete a deep 39-question profiling that maps your emotional, professional and decision-making patterns.",
      how_2_title: "Daily Mentorship",
      how_2_desc: "Talk with B — a firm, fair, empathetic mentor — to navigate decisions and contain impulsivity.",
      how_3_title: "Weekly Insights",
      how_3_desc: "Get on-demand reports analyzing emotions, patterns, decision quality, and progress toward your goals.",
      benefits_title: "What you'll gain",
      benefit_1: "Better professional decisions",
      benefit_2: "Emotional regulation in pressure",
      benefit_3: "Detection of impulsive patterns",
      benefit_4: "Stronger workplace relationships",
      benefit_5: "Strategic clarity, daily",
      benefit_6: "Personalized behavioral analysis",
      pricing_title: "Simple pricing. 7 days free.",
      pricing_subtitle: "Cancel anytime. No hidden fees. No credit card required.",
      plan_monthly: "Monthly",
      plan_annual: "Annual",
      per_month: "/month",
      per_year: "/year",
      save_percent: "Save 17%",
      trial_badge: "7-day free trial",
      cancel_anytime: "Cancel anytime",
      no_card: "No credit card required",
      disclaimer_title: "Important disclaimer",
      disclaimer_body: "This application does not replace therapy, psychologists, psychiatrists, doctors, or certified professionals. It does not offer clinical diagnosis or treatment. It is an emotional and professional support tool based on behavioral analysis and artificial intelligence. The user is responsible for their decisions.",
    },
    auth: {
      login_title: "Welcome back",
      login_subtitle: "Continue your scan",
      login_tag: "/ Login",
      register_title: "Create your account",
      register_subtitle: "Begin your mental scan",
      register_tag: "/ Register",
      email: "Email",
      password: "Password",
      full_name: "Full name",
      login_btn: "Log in",
      register_btn: "Create account",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      sign_up: "Sign up",
      sign_in: "Sign in",
      welcome_back: "Welcome back",
      login_failed: "Login failed",
      account_created: "Account created",
      registration_failed: "Registration failed",
      password_too_short: "Password must be at least 6 characters",
      or_divider: "or",
    },
    questionnaire: {
      title: "Initial Mental Scan",
      subtitle: "B needs to understand you before guiding you. Answer honestly.",
      progress: "Section",
      of: "of",
      finish: "Complete Scan",
      start: "Start Scan",
      saving: "Analyzing your profile...",
      cant_skip: "You must complete the scan before accessing the mentor.",
      honesty_title: "Why your honesty matters",
      honesty_lead: "This is not a routine form. Every answer becomes the foundation B uses to mentor you with precision.",
      honesty_b1: "Your answers personalize every recommendation, every report, and every conversation with B.",
      honesty_b2: "There are no right or wrong answers. There is only your truth.",
      honesty_b3: "The more honest you are, the sharper and more useful the guidance you'll receive.",
      honesty_footer: "Take your time. Breathe. Answer from where you really are — not from where you think you should be.",
    },
    dashboard: {
      welcome: "Welcome back",
      subtitle: "Your mental dashboard",
      emotional_state: "Emotional State",
      impulsivity: "Impulsivity Level",
      progress: "Professional Progress",
      alerts: "Behavior Alerts",
      recommendations: "Weekly Recommendations",
      no_alerts: "No alerts. You're tracking well.",
      no_recommendations: "Generate a report to see recommendations.",
      generate_report: "Generate Weekly Report",
      latest_report: "Latest report",
      open_chat: "Open mentor chat",
    },
    chat: {
      title: "B — Your Personal Mentor",
      subtitle: "Firm. Fair. Empathetic.",
      placeholder: "Share what's on your mind...",
      send: "Send",
      thinking: "Thinking...",
      empty_title: "Start a conversation with B",
      empty_subtitle: "She knows your profile. Ask anything about decisions, emotions or relationships.",
    },
    goals: {
      title: "Professional Goals",
      subtitle: "Track your strategic progress",
      add_goal: "Add goal",
      goal_title: "Goal title",
      goal_description: "Description",
      target_date: "Target date",
      progress: "Progress",
      no_goals: "No goals yet. Add your first strategic goal.",
      mark_complete: "Mark complete",
      active: "Active",
      completed: "Completed",
    },
    reports: {
      title: "Weekly Reports",
      subtitle: "On-demand behavioral analysis",
      generate: "Generate report now",
      generating: "Analyzing the week...",
      no_reports: "No reports yet. Generate your first weekly analysis.",
      emotional_summary: "Emotional Summary",
      patterns: "Detected Patterns",
      decisions: "Decision Quality",
      alerts: "Impulsivity Alerts",
      recommendations: "Strategic Recommendations",
      goals_progress: "Goals Progress",
      score: "Overall Score",
    },
    subscription: {
      title: "Choose your plan",
      subtitle: "7 days free trial. Cancel anytime.",
      current_plan: "Current plan",
      trial: "Trial",
      active: "Active",
      monthly: "Monthly",
      annual: "Annual",
      subscribe: "Subscribe",
      processing: "Processing...",
      success_title: "Welcome to BScanIA",
      success_subtitle: "Your subscription is active.",
      go_dashboard: "Go to Dashboard",
      verifying: "Verifying payment...",
    },
  },
  es: {
    common: {
      loading: "Cargando...",
      save: "Guardar",
      cancel: "Cancelar",
      submit: "Enviar",
      next: "Siguiente",
      back: "Atrás",
      delete: "Eliminar",
      edit: "Editar",
      logout: "Cerrar sesión",
    },
    nav: {
      dashboard: "Panel",
      chat: "Chat Mentor",
      decisions: "Decisiones",
      goals: "Metas",
      reports: "Reportes",
      journey: "Mi Camino",
      subscription: "Suscripción",
      settings: "Ajustes",
      group_tools: "Herramientas",
      group_reflection: "Reflexión",
      group_account: "Cuenta",
    },
    landing: {
      brand: "BScanIA",
      tagline: "El Socio Inteligente Detrás de Cada Decisión Estratégica.",
      subtitle: "BScanIA es tu socio de IA estratégico y emocionalmente inteligente, que permite decisiones claras y no impulsivas alineadas con las expectativas organizacionales. Diseñado para stakeholders y managers de múltiples industrias.",
      cta_start: "Empieza antes de tu próxima decisión",
      cta_login: "Iniciar sesión",
      how_title: "Cómo funciona",
      how_subtitle: "Tres pasos hacia la claridad mental",
      how_1_title: "Escaneo Inicial",
      how_1_desc: "Completa un perfilado profundo de 39 preguntas que mapea tus patrones emocionales, profesionales y de decisión.",
      how_2_title: "Mentoría Diaria",
      how_2_desc: "Conversa con B — un mentor firme, justo y empático — para navegar decisiones y contener la impulsividad.",
      how_3_title: "Análisis Semanal",
      how_3_desc: "Recibe reportes a demanda analizando emociones, patrones, calidad de decisiones y progreso hacia tus metas.",
      benefits_title: "Lo que ganarás",
      benefit_1: "Mejores decisiones profesionales",
      benefit_2: "Regulación emocional bajo presión",
      benefit_3: "Detección de patrones impulsivos",
      benefit_4: "Relaciones laborales más fuertes",
      benefit_5: "Claridad estratégica diaria",
      benefit_6: "Análisis conductual personalizado",
      pricing_title: "Precios simples. 7 días gratis.",
      pricing_subtitle: "Cancela cuando quieras. Sin cargos ocultos. Sin tarjeta de crédito.",
      plan_monthly: "Mensual",
      plan_annual: "Anual",
      per_month: "/mes",
      per_year: "/año",
      save_percent: "Ahorra 17%",
      trial_badge: "7 días gratis",
      cancel_anytime: "Cancela cuando quieras",
      no_card: "Sin tarjeta de crédito",
      disclaimer_title: "Descargo importante",
      disclaimer_body: "Esta aplicación no sustituye terapia, psicólogos, psiquiatras, médicos ni profesionales certificados. No ofrece diagnóstico clínico ni tratamiento. Es una herramienta de apoyo emocional y profesional basada en análisis de comportamiento e inteligencia artificial. El usuario es responsable de sus decisiones.",
    },
    auth: {
      login_title: "Bienvenido de vuelta",
      login_subtitle: "Continúa tu escaneo",
      login_tag: "/ Iniciar sesión",
      register_title: "Crea tu cuenta",
      register_subtitle: "Inicia tu escaneo mental",
      register_tag: "/ Registro",
      email: "Correo",
      password: "Contraseña",
      full_name: "Nombre completo",
      login_btn: "Iniciar sesión",
      register_btn: "Crear cuenta",
      no_account: "¿No tienes cuenta?",
      have_account: "¿Ya tienes cuenta?",
      sign_up: "Regístrate",
      sign_in: "Inicia sesión",
      welcome_back: "Bienvenido de vuelta",
      login_failed: "Error al iniciar sesión",
      account_created: "Cuenta creada",
      registration_failed: "No se pudo registrar",
      password_too_short: "La contraseña debe tener al menos 6 caracteres",
      or_divider: "o",
    },
    questionnaire: {
      title: "Escaneo Mental Inicial",
      subtitle: "B necesita entenderte antes de guiarte. Responde con honestidad.",
      progress: "Sección",
      of: "de",
      finish: "Completar escaneo",
      start: "Iniciar escaneo",
      saving: "Analizando tu perfil...",
      cant_skip: "Debes completar el escaneo antes de acceder al mentor.",
      honesty_title: "Por qué tu honestidad importa",
      honesty_lead: "Esto no es un formulario de trámite. Cada respuesta se convierte en la base con la que B te acompañará con precisión.",
      honesty_b1: "Tus respuestas personalizan cada recomendación, cada reporte y cada conversación con B.",
      honesty_b2: "No hay respuestas correctas ni incorrectas. Solo está tu verdad.",
      honesty_b3: "Mientras más honesto seas, más afilada y útil será la guía que recibas.",
      honesty_footer: "Tómate tu tiempo. Respira. Responde desde donde realmente estás, no desde donde crees que deberías estar.",
    },
    dashboard: {
      welcome: "Bienvenido",
      subtitle: "Tu panel mental",
      emotional_state: "Estado Emocional",
      impulsivity: "Nivel de Impulsividad",
      progress: "Progreso Profesional",
      alerts: "Alertas de Comportamiento",
      recommendations: "Recomendaciones Semanales",
      no_alerts: "Sin alertas. Vas bien.",
      no_recommendations: "Genera un reporte para ver recomendaciones.",
      generate_report: "Generar Reporte Semanal",
      latest_report: "Último reporte",
      open_chat: "Abrir chat mentor",
    },
    chat: {
      title: "B — Tu Mentor Personal",
      subtitle: "Firme. Justa. Empática.",
      placeholder: "Comparte lo que tienes en mente...",
      send: "Enviar",
      thinking: "Pensando...",
      empty_title: "Inicia una conversación con B",
      empty_subtitle: "Ella conoce tu perfil. Pregunta sobre decisiones, emociones o relaciones.",
    },
    goals: {
      title: "Metas Profesionales",
      subtitle: "Sigue tu progreso estratégico",
      add_goal: "Agregar meta",
      goal_title: "Título de la meta",
      goal_description: "Descripción",
      target_date: "Fecha objetivo",
      progress: "Progreso",
      no_goals: "Sin metas. Agrega tu primera meta estratégica.",
      mark_complete: "Marcar completa",
      active: "Activa",
      completed: "Completada",
    },
    reports: {
      title: "Reportes Semanales",
      subtitle: "Análisis de comportamiento a demanda",
      generate: "Generar reporte ahora",
      generating: "Analizando la semana...",
      no_reports: "Sin reportes. Genera tu primer análisis semanal.",
      emotional_summary: "Resumen Emocional",
      patterns: "Patrones Detectados",
      decisions: "Calidad de Decisiones",
      alerts: "Alertas de Impulsividad",
      recommendations: "Recomendaciones Estratégicas",
      goals_progress: "Progreso de Metas",
      score: "Puntaje General",
    },
    subscription: {
      title: "Elige tu plan",
      subtitle: "7 días gratis. Cancela cuando quieras.",
      current_plan: "Plan actual",
      trial: "Prueba",
      active: "Activo",
      monthly: "Mensual",
      annual: "Anual",
      subscribe: "Suscribirse",
      processing: "Procesando...",
      success_title: "Bienvenido a BScanIA",
      success_subtitle: "Tu suscripción está activa.",
      go_dashboard: "Ir al Panel",
      verifying: "Verificando pago...",
    },
  },
};
